import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getBannerList(status) {
    const params = { status };
    const url = '/banners';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getBanner(id) {
    return api.get(`/banners/${id}`);
  },
  createBanner(payload) {
    return api.post(`/banners`, { banner: payload });
  },
  updateBannerDetail(payload) {
    return api.put(`/banners`, { banners: payload });
  },
  updateBannerOrder(payload) {
    return api.put(`/banners/update_order`, { banners: payload });
  },
  hideBanner(id) {
    return api.delete(`/banners/${id}`);
  },
  restoreBanner(id) {
    return api.put(`/banners/${id}/reactivate`);
  },

  deleteBanner(id) {
    return api.delete(`/banners/${id}/delete`);
  },
};
